import styled, { css } from 'styled-components';

export const TimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 70px;
`;

export interface TimerTextProps {
	$color: string;
}

export const TimerText = styled.span<TimerTextProps>`
	${({ theme, $color }) => css`
		color: ${$color};
		font-size: ${theme.fontSizes.default};
		font-weight: ${theme.fontWeights.medium};
		line-height: 1;
		font-variant-numeric: tabular-nums;
		min-width: 44px;
	`}
`;

